var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoUniversalDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg2",
    xmlSpace: "preserve",
    width: 346,
    height: 84.226669,
    viewBox: "0 0 346 84.226669",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g8",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,84.226667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g10",
    transform: "scale(0.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 2221.22,302.148 v -30.41 c 8.84,4.453 17.09,9.512 26.58,15.84 3.81,-13.926 13.94,-23.437 31.03,-23.437 13.94,0 34.2,9.511 51.94,19.648 v 0 31.66 c -13.95,-10.781 -17.74,-10.781 -21.55,-10.781 -6.32,0 -10.13,3.809 -10.13,10.781 v 0 82.324 c 0,37.989 -31.03,51.309 -72.18,51.309 -1.91,0 -3.8,-0.644 -5.69,-0.644 v 0 -37.364 c 17.71,-2.519 23.41,-12.031 23.41,-26.601 -8.24,-3.164 -15.82,-5.684 -23.41,-8.223 v 0 -30.391 c 6.95,3.145 14.56,6.309 23.41,10.118 v 0 -43.692 c -8.24,-5.703 -15.19,-8.867 -23.41,-10.137 v 0",
    style: {
      fill: "#243c79",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2344.07,270.488 h 54.4688 V 532.031 H 2344.07 Z",
    style: {
      fill: "#243c79",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2221.22,411.074 v 37.364 c -28.52,-0.645 -51.32,-6.954 -72.86,-19.649 v 0 -44.316 c 16.48,17.09 43.72,27.246 64.61,27.246 3.17,0 5.71,-0.645 8.25,-0.645 v 0",
    style: {
      fill: "#243c79",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2221.22,345.859 v 30.391 c -56.38,-18.379 -80.45,-27.871 -80.45,-63.965 0,-24.707 20.9,-48.144 48.77,-48.144 10.76,0 21.54,2.519 31.68,7.597 v 0 30.41 c -2.54,-0.644 -5.72,-0.644 -8.25,-0.644 -10.13,0 -17.11,6.973 -17.11,17.09 0,12.051 8.88,19.004 25.36,27.265 v 0",
    style: {
      fill: "#243c79",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1725.94,303.418 v -39.277 c 1.92,0 3.81,0 5.71,0 13.3,0 44.33,0 78.53,27.246 v 0 34.199 c -27.23,-20.918 -44.34,-24.082 -65.23,-24.082 -6.98,0 -13.3,0.644 -19.01,1.914 v 0",
    style: {
      fill: "#243c79",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1725.94,376.875 v -27.227 h 84.24 c 3.16,62.696 -35.47,96.875 -84.24,98.79 v 0 -31.036 c 19.64,-0.625 37.38,-17.089 37.38,-40.527 v 0 h -37.38",
    style: {
      fill: "#243c79",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1893.15,446.523 h -55.12 V 270.488 h 55.12 v 75.371 c 13.93,34.2 27.23,51.914 45.59,51.914 9.51,0 19.63,-3.144 33.57,-13.3 v 0 l 13.93,51.289 c -13.93,10.761 -24.06,13.32 -34.2,13.32 -20.9,0 -41.16,-17.734 -58.89,-51.309 v 0 48.75",
    style: {
      fill: "#243c79",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2119.87,435.762 c -16.47,10.761 -33.58,13.32 -58.26,13.32 -41.18,0 -72.21,-20.293 -72.21,-54.453 0,-55.742 89.3,-51.953 89.3,-76.035 0,-10.117 -10.12,-13.926 -27.23,-13.926 -20.25,0 -41.17,7.617 -58.26,13.926 v 0 -37.344 c 6.34,-3.789 34.2,-17.109 65.23,-17.109 44.96,0 69.65,23.437 69.65,61.445 0,58.887 -86.75,58.887 -86.75,79.805 0,9.472 13.29,12.656 20.27,12.656 10.13,0 34.2,-6.328 58.26,-20.274 v 0 37.989",
    style: {
      fill: "#243c79",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1061.59,270.488 h 54.48 v 176.035 h -54.48 v -110.8 c -8.23,-17.129 -21.53,-31.055 -38.62,-31.055 -13.94,0 -28.501,7.617 -28.501,34.219 v 0 107.636 H 940.641 V 333.164 c 0,-45.586 27.234,-69.023 61.429,-69.023 24.7,0 41.8,9.511 59.52,29.765 v 0 -23.418",
    style: {
      fill: "#243c79",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1725.94,417.402 v 31.036 c -1.25,0 -2.52,0.644 -3.79,0.644 -55.09,0 -93.09,-37.363 -93.09,-93.105 0,-53.204 38.62,-89.942 96.88,-91.836 v 0 39.277 c -23.44,5.059 -38.61,20.898 -38.61,46.23 v 0 h 38.61 v 27.227 h -38.61 c 2.52,28.516 16.45,41.172 37.36,41.172 0.63,0 1.25,-0.645 1.25,-0.645 v 0",
    style: {
      fill: "#243c79",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1209.17,446.523 h -55.1 V 270.488 h 55.1 v 113.985 c 13.29,20.918 23.42,27.246 37.36,27.246 17.73,0 27.22,-10.156 27.22,-34.844 v 0 -106.387 h 55.75 v 113.985 c 0,51.289 -38.01,64.609 -65.24,64.609 -20.9,0 -38.63,-6.348 -55.09,-27.246 v 0 24.687",
    style: {
      fill: "#243c79",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1366.86,270.488 h 55.1016 V 446.523 H 1366.86 Z",
    style: {
      fill: "#243c79",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1394.09,535.84 c -17.09,0 -30.39,-13.926 -30.39,-31.66 0,-17.129 13.3,-31.68 30.39,-31.68 17.73,0 31.67,14.551 31.67,31.68 0,17.734 -13.94,31.66 -31.67,31.66 v 0",
    style: {
      fill: "#243c79",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1518.23,264.141 h 31.03 l 79.8,182.382 h -59.54 l -37.35,-96.875 -38.01,96.875 h -58.28 l 82.35,-182.382",
    style: {
      fill: "#243c79",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 2508.72,34.9023 V 0.0585938 c 1.28,0 2.53,0 4.45,0 14.55,0 46.85,0 79.16,23.4375062 v 0 34.8047 c -25.98,-18.9649 -43.7,-25.3125 -65.24,-25.3125 -6.96,0 -12.66,0.625 -18.37,1.914 v 0",
    style: {
      fill: "#243c79",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 2508.72,111.523 V 82.3828 h 86.15 c 2.52,62.7152 -36.75,98.8082 -86.15,100.7032 v 0 -32.93 c 20.27,0 34.84,-15.215 38.01,-38.633 v 0 h -38.01",
    style: {
      fill: "#243c79",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2508.72,150.156 v 32.93 c -1.25,0 -3.16,0.625 -4.42,0.625 -53.85,0 -93.1,-39.258 -93.1,-92.461 0,-54.4727 37.99,-89.92187 97.52,-91.1914062 v 0 V 34.9023 c -23.42,5.0782 -38.62,22.1485 -39.89,47.4805 v 0 h 39.89 v 29.1402 h -39.26 c 2.54,24.707 16.47,39.258 38.63,39.258 v 0 l 0.63,-0.625",
    style: {
      fill: "#243c79",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1903.29,33.6133 V 5.78125 c 8.22,3.16406 16.44,7.57815 25.95,13.92575 4.44,-13.92575 13.95,-19.6484062 32.31,-19.6484062 13.93,0 36.72,6.3085962 51.93,15.8203062 v 0 31.0352 c -13.93,-8.8477 -18.38,-10.1368 -21.54,-10.1368 -5.06,0 -8.87,4.4532 -8.87,12.6954 v 0 80.4103 c 0,38.633 -30.39,53.828 -75.35,53.828 -1.91,0 -3.18,-0.625 -4.43,-0.625 v 0 -37.988 c 18.36,-2.559 24.68,-13.321 24.68,-28.535 -8.86,-3.145 -17.09,-5.665 -24.68,-7.559 v 0 -29.7852 c 6.96,2.539 15.19,5.6835 24.68,8.8476 v 0 -41.1523 c -8.24,-6.9336 -16.46,-12.0118 -24.68,-13.3008 v 0",
    style: {
      fill: "#243c79",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2081.88,179.922 h -55.74 V 3.20313 h 55.74 V 117.207 c 13.28,22.188 25.32,28.516 37.99,28.516 16.46,0 27.87,-10.137 27.87,-34.825 v 0 V 3.20313 h 55.1 V 115.977 c 0,51.894 -36.73,67.734 -63.97,67.734 -22.8,0 -39.28,-8.867 -56.99,-29.141 v 0 25.352",
    style: {
      fill: "#243c79",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2392.82,51.9922 c -24.69,-9.4922 -36.1,-12.6563 -49.4,-12.6563 -32.28,0 -53.2,21.5235 -53.2,52.5391 0,30.43 22.19,50.664 54.47,50.664 13.94,0 31.04,-3.789 45.61,-12.012 v 0 41.153 c -17.74,6.953 -41.17,12.031 -58.91,12.031 -58.89,0 -100.06,-39.258 -100.06,-92.461 0,-55.0977 39.91,-91.1914062 101.97,-91.1914062 18.37,0 36.72,3.7890662 59.52,12.0508062 v 0 39.8828",
    style: {
      fill: "#243c79",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1903.29,145.098 v 37.988 c -25.34,-0.645 -49.42,-8.242 -70.94,-20.898 v 0 -45.625 c 17.1,17.773 42.44,29.16 64.6,29.16 1.89,0 4.43,-0.625 6.34,-0.625 v 0",
    style: {
      fill: "#243c79",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1903.29,79.2188 v 29.7852 c -56.37,-17.754 -80.44,-29.1602 -80.44,-65.879 0,-22.1484 20.9,-43.0664062 49.4,-43.0664062 10.76,0 20.9,1.2695362 31.04,5.7226562 v 0 27.83205 c -1.91,-0.625 -4.45,-0.625 -6.34,-0.625 -9.5,0 -18.37,8.8672 -18.37,19.0039 0,12.0508 7.6,19.6289 24.71,27.2266 v 0",
    style: {
      fill: "#243c79",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1014.09,33.6133 V 5.78125 c 8.24,3.16406 16.47,7.57815 25.97,13.92575 3.81,-13.92575 12.04,-19.6484062 31.04,-19.6484062 14.57,0 36.73,6.3085962 51.93,15.8203062 v 0 31.0352 c -13.29,-8.8477 -17.73,-10.1368 -20.9,-10.1368 -5.06,0 -9.49,4.4532 -9.49,12.6954 v 0 80.4103 c 0,38.633 -31.05,53.828 -74.1,53.828 -1.91,0 -3.17,-0.625 -4.45,-0.625 v 0 -37.988 c 17.75,-2.559 23.44,-13.965 23.44,-28.535 -8.23,-2.52 -15.84,-5.04 -23.44,-7.559 v 0 -29.7852 c 6.98,3.164 14.58,5.6835 23.44,8.8476 v 0 -41.1523 c -7.6,-6.9336 -15.2,-11.3868 -23.44,-13.3008 v 0",
    style: {
      fill: "#243c79",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1256.67,169.785 c -17.74,10.137 -34.21,13.926 -57,13.926 -43.08,0 -72.2,-21.523 -72.2,-55.098 0,-57.6169 87.38,-51.9333 87.38,-78.4958 0,-7.6172 -10.75,-13.3399 -26.58,-13.3399 -21.53,0 -39.91,7.5977 -57.01,15.2149 v 0 -38.6328 c 6.97,-4.41409 34.21,-13.3008062 62.71,-13.3008062 45.59,0 72.19,20.2734062 72.19,57.6172062 0,58.8872 -88.03,59.5312 -88.03,79.1792 0,12.051 12.67,13.926 20.27,13.926 11.4,0 34.19,-5.058 58.27,-19.648 v 0 38.652",
    style: {
      fill: "#243c79",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1410.57,169.785 c -18.38,10.137 -35.49,13.926 -57.65,13.926 -43.06,0 -72.19,-21.523 -72.19,-55.098 0,-57.6169 86.77,-51.9333 86.77,-78.4958 0,-7.6172 -10.15,-13.3399 -26.62,-13.3399 -21.52,0 -38.63,7.5977 -56.36,15.2149 v 0 -38.6328 c 7.6,-4.41409 34.21,-13.3008062 63.34,-13.3008062 45.59,0 70.93,20.2734062 70.93,57.6172062 0,58.8872 -88.03,59.5312 -88.03,79.1792 0,12.051 12.66,13.926 20.9,13.926 10.77,0 33.56,-5.058 58.91,-19.648 v 0 38.652",
    style: {
      fill: "#243c79",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1443.49,3.20313 h 54.4609 v 176.719 H 1443.49 Z",
    style: {
      fill: "#243c79",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1470.72,267.324 c -17.1,0 -31.03,-12.676 -31.03,-30.39 0,-16.485 13.93,-29.786 31.03,-29.786 16.47,0 31.03,13.301 31.03,29.786 0,17.714 -14.56,30.39 -31.03,30.39 v 0",
    style: {
      fill: "#243c79",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1655.65,169.785 c -17.09,10.137 -34.2,13.926 -57,13.926 -43.06,0 -72.2,-21.523 -72.2,-55.098 0,-57.6169 87.4,-51.9333 87.4,-78.4958 0,-7.6172 -10.13,-13.3399 -25.97,-13.3399 -22.17,0 -40.53,7.5977 -57.63,15.2149 v 0 -38.6328 c 7.61,-4.41409 34.21,-13.3008062 62.7,-13.3008062 45.61,0 72.84,20.2734062 72.84,57.6172062 0,58.8872 -88.03,59.5312 -88.03,79.1792 0,12.051 12.03,13.926 19.63,13.926 12.03,0 35.47,-5.058 58.26,-19.648 v 0 38.652",
    style: {
      fill: "#243c79",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1814.61,179.922 h -63.96 v 55.742 h -6.96 l -73.47,-82.344 v -10.781 h 25.33 V 65.9375 c 0,-49.4336 31.03,-65.8789062 68.4,-65.8789062 17.09,0 31.04,2.5390662 50.66,10.7617062 v 0 41.1719 c -14.57,-8.8672 -25.31,-10.7617 -36.73,-10.7617 -17.74,0 -27.23,10.7617 -27.23,27.8515 v 0 73.457 h 63.96 v 37.383",
    style: {
      fill: "#243c79",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1014.09,145.098 v 37.988 c -26.586,-0.645 -50.652,-7.617 -72.18,-20.898 v 0 -45.625 c 17.723,17.773 42.43,29.16 64.59,29.16 2.53,0 5.71,-0.625 7.59,-0.625 v 0",
    style: {
      fill: "#243c79",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1014.09,79.2188 V 109.004 C 957.094,91.25 932.402,79.8438 932.402,43.125 c 0,-22.1484 21.536,-43.0664062 50.039,-43.0664062 10.118,0 20.889,1.9140662 31.649,5.7226562 v 0 27.83205 c -2.52,-0.625 -5.06,-0.625 -7.59,-0.625 -9.492,0 -17.73,8.8672 -17.73,19.0039 0,12.0508 8.238,20.2539 25.32,27.2266 v 0",
    style: {
      fill: "#243c79",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0.3125,631.719 H 259.879 L 259.563,469.18 0,234.16 0.3125,631.719",
    style: {
      fill: "#243c79",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 727.406,261.211 V 630.566 H 467.523 V 550.059 C 428.684,537.012 392.676,525.547 359.238,514.707 107.324,432.539 0,394.648 0,222.363 0,112.793 93.6328,0.0585938 218.801,0.0585938 c 49.676,0 94.89,13.0469062 140.437,34.7070062 40.774,19.1211 81.532,45.2149 126.117,75.1564 C 501.277,46.875 548.105,1.01563 626.449,0.0585938 675.484,-0.585938 754.156,3.88672 805.43,26.5039 v 0 l 25.804,156.6801 c -51.921,0 -103.828,25.8 -103.828,78.027 z M 467.523,222.363 c -36.941,-24.843 -71.972,-41.406 -108.285,-47.48 -10.179,-1.895 -20.383,-2.539 -30.57,-2.539 -46.813,0 -78.348,31.543 -78.348,78.672 0,54.804 37.578,86.621 108.918,122.617 30.254,15.312 66.254,31.211 108.285,50 v 0 -201.27",
    style: {
      fill: "#0895a4",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path76"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoUniversalDark);
export default __webpack_public_path__ + "static/media/logo-universal-dark.a94ef41af0b360bda8346f9880254a6b.svg";
export { ForwardRef as ReactComponent };